import { Component, OnInit, OnDestroy } from "@angular/core";
import { CouponsService } from "../services/coupons.service";
const alertify = require("alertify.js");
import { Title } from '@angular/platform-browser';

@Component({
  selector: "ch-coupons-listing",
  templateUrl: "./coupons-listing.component.html",
  styleUrls: ["./coupons-listing.component.css"]
})
export class CouponsListingComponent implements OnInit, OnDestroy {
  public items = [];
  public totalItems;
  public pageParams: any = {};

  public loading: boolean;

  public breadcrumb: string[] = [];

  constructor(private couponsService: CouponsService, private titleService: Title) {
    alertify.logPosition("bottom right");
  }

  ngOnInit() {
    this.titleService.setTitle(`Coupons | CODE Hospitality CMS`);
    this.loadItems();
    this.breadcrumb = ["Coupons"];
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  private loadItems() {
    this.loading = true;
    const handle = result => {
      const jsonData = result.json();
      this.items = jsonData;
      this.totalItems = jsonData.length;
      this.loading = false;
    };
    this.couponsService.getAllCoupons().subscribe(handle);
  }

  public deleteCoupon(id: string) {
    if (!confirm("Are you sure you want to delete this coupon?")) {
      return;
    }
    this.loading = true;
    this.couponsService.deleteCoupon(id).subscribe(
      _ => {
        this.loadItems();
      },
      err => {
        this.loading = false;
        this.alertError(err)
      }
    );
  }

  private alertError(error: any) {
    if (!error.error) {
      alertify.error(`There was a ${error.status} error with the request.`);
    } else {
      alertify.error(
        `There was a ${error.status} error with message '${error.error}'.`
      );
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/coupons/coupons-listing/coupons-listing.component.ts